import React from 'react';
import 'material-icons/iconfont/material-icons.css';
import { Routes } from 'react-router-dom';
import styled from 'styled-components';

// import AdmRoutes from './Rotas/AdmRoutes';
import AdmRoutes from './Rotas/AdmRoutes';
import ContratosRoutes from './Rotas/Contratos';
import HomeRoutes from './Rotas/HomeRoutes';
import MeusDadosRoutes from './Rotas/MeusDadosRoutes';
import PautasRoutes from './Rotas/Pautas';
import Breadcrumbs from '../../../components/BreadCrumb';
import Sidebar from '../../../components/Sidebar';
import {
  hasTpVinculo,
  isAdmin,
  // isAdmin,
  useNomeCompleto,
} from '../../../modules/contexts/userContexts';

const Container = styled.div`
  display: grid;
  // max-content - ocupa exatamente o tamanho necessário para o conteúdo mais largo dentro da sidebar (sem quebrar o texto)
  // 1fr (uma fração do espaço restante) para ocupar o espaço restante
  grid-template-columns: max-content 1fr;
  min-height: 100vh;
`;

const WorkspaceContainer = styled.div`
  display: grid;
  grid-template-rows: 5vh 95vh;
`;

const Workspace = styled.div`
  background-color: ${({ theme }) => theme.colors.fundo};
  height: calc(100vh - 5vh);
  overflow-x: hidden;
  display: grid;
  grid-template-rows: 5% 90% 5%;
`;
const dominioFornecedor = 'fornecedor';

export default function AppFornecedor() {
  const { papel } = useNomeCompleto();
  const isUserAdmin = isAdmin(papel) || hasTpVinculo();

  return (
    <Container>
      <Sidebar />
      <WorkspaceContainer>
        <Breadcrumbs tipoSubdominio={dominioFornecedor} />
        <Workspace>
          <Routes>
            {HomeRoutes()}
            {ContratosRoutes()}
            {PautasRoutes()}
            {MeusDadosRoutes()}
            {isUserAdmin && AdmRoutes()}
          </Routes>
        </Workspace>
      </WorkspaceContainer>
    </Container>
  );
}

// export default AppFornecedor;
